import { createContextFactory } from '@streem/toolbox';
export const [CallSourceProvider, useCallSource] = createContextFactory('CallSource');
//# sourceMappingURL=call_source.js.map